import {
  ActivityLogActions,
  ActivityLogReducerState,
  FETCH_ACTIVITY_IS_COMPLETE,
  FETCH_ACTIVITY_IS_ERROR,
  FETCH_ACTIVITY_IS_PENDING,
  SORT,
} from 'services/Account/ActivityLog/types';
import dateToUnix from 'utils/date/dateToUnix';
import { sort } from 'utils/functions';

const INITIAL_STATE = {
  activityLog: [],
  sortBy: 'date',
  sortDirection: 'DESC',
  params: {
    type: 'function',
    sortSearchParam: 'date',
    sortSearchValue: (item: $TSFixMe) => {
      const timestap = dateToUnix(`${item.date} ${item.time}`);

      return timestap;
    },
  },
  activityIsCompleted: false,
  activityIsPending: false,
  activityIsError: null,
} satisfies ActivityLogReducerState;

const activityReducer = (previousState: ActivityLogReducerState | undefined, action: ActivityLogActions): ActivityLogReducerState => {
  const state: ActivityLogReducerState = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case FETCH_ACTIVITY_IS_COMPLETE: {
      return {
        ...state,
        activityLog: sort(action.data ?? [], {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: state.params?.sortSearchValue ?? state.params?.value,
        }),
        activityIsCompleted: true,
        activityIsPending: false,
        activityIsError: null,
      };
    }

    case FETCH_ACTIVITY_IS_PENDING: {
      return {
        ...state,
        activityIsCompleted: false,
        activityIsPending: true,
        activityIsError: null,
      };
    }

    case FETCH_ACTIVITY_IS_ERROR: {
      return {
        ...state,
        activityIsCompleted: true,
        activityIsPending: false,
        activityIsError: action.error,
      };
    }

    case SORT:
      return {
        ...state,
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
        params: action.params,
        activityLog: sort(state.activityLog, {
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };

    default:
      return state;
  }
};

export default activityReducer;
